import React from 'react';
import { connect } from 'react-redux';

import ShoutBox from './Shoutbox.component';

const mapStateToProps = (state) => {
	const {
		submission: {
			focussed,
		},
	} = state;
	return {
		focussed,
	};
};

export default connect(mapStateToProps)(ShoutBox);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/Shoutbox.container.js